import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class IndustryCategoryFilter extends Component {
    state = {
         industryCategoryList:[],
         industryCategoryValue: null,
         isLoading: true
    };
    componentDidMount(){
        this.getIndustryCategory();
    }

    resetIndustryCategoryFilter(){
        this.setState({
        industryCategoryValue: [],
        })
    }
     getIndustryCategory(){
        axios.get(config.get('API_URL')+'/filters/get-industry-category/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((cat, index) => {
                    this.state.industryCategoryList.push({value: cat.category_code, label: cat.category_name})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    changeIndustryCategory(optionSelected){
        let value='';
        let catArray = [];
        if(optionSelected.length < 1){
            value = null;
            catArray='';
        }
        else{
            optionSelected.map((cat, i) => {
                catArray.push(cat.value)
                var index = this.state.industryCategoryList.findIndex(obj => obj.value==cat.value);
                this.state.industryCategoryList.move(index,0).join(',');
            });
        }
        this.props.onSelectIndustryCategoryFilter(optionSelected,catArray);

        this.setState({
            industryCategoryValue:optionSelected,
        });
    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="city"
            isMulti
            value={this.state.industryCategoryValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeIndustryCategory.bind(this)}
            options={this.state.industryCategoryList}
            placeholderButtonLabel="Select [Industry Category]"
        />
        );

    }
}
export default IndustryCategoryFilter;